<template>
    <div>
        <div class="channel-group">
            <ChannelGroupCon class="personal-account-number" title="个人账号" :isPerson="true" ref="personMediaAccount"
                :defaultSelectedMediaList="defaultSelectedMediaList" :media-group="userMediaGroup"
                @select-media="selectMedia" @select-account="selectAccount" />
            <ChannelGroupCon class="public-account-number" title="公共账号" :media-group="pubMediaGroup"
                @select-media="selectMedia" @select-account="selectAccount" />
        </div>
        <!-- 显示或隐藏个性编辑区域内容 -->
        <div class="personal-edit">
            <div class="personal-edit-header" style="cursor: pointer" @click="editDistributeInfo">
                {{ customDistributeMode ? '智能编目' : '个性编目'}}
                <i class="ico-writing" :class="customDistributeMode ? ' ico-drap-up' : 'ico-drap-down'"></i>
            </div>
            <ul class="personal-edit-content" v-if="customDistributeMode">
                <!--微信和看点的编目需要个性化配置-->
                <li class="f-clearfix pec-list" v-for="item in selectedMediaList" :key="item.enName+item.id">
                    <div class="img-upload" v-if="item.enName === 'wx'">
                        <tgl-image-cloud-upload class="hide-add-icon" :editBtn="true" :domWidth="207"
                            :domHeight="124" :maxSize="30720" :height="128" :width="128" :isCrop="true"
                            :btnId="item.enName" :ref="'imgUpload'+item.enName" @completed="imageUploadCompleted"
                            :choiceType="item">
                            <template #text>
                                <div class="upload-text">点击上传封面图片</div>
                                <div class="upload-text">最大：30K，尺寸：128*128</div>
                            </template>
                            <template #footer>
                                <div style="font-size: 14px;">{{item.name}}</div>
                            </template>
                        </tgl-image-cloud-upload>
                        <div class="size-advice f-hide-col-1" style="text-align: center">尺寸：128*128，最大：30K</div>
                        <br>
                        <div style="display: inline-block">
                            <tgl-image-cloud-upload class="hide-add-icon" :editBtn="true" :isCrop="true"
                                :domWidth="207" :domHeight="124" :width="670" :height="376" extra="wx" :btnId="item.enName+'Extra'"
                                :ref="'imgUpload'+item.enName" :choiceType="{name:item.name, cover:item.coverExtra}"
                                @completed="imageUploadCompleted">
                                <template #text>
                                    <div class="upload-text">上传推荐图</div>
                                    <div class="upload-text">尺寸：670*376</div>
                                </template>
                                <template #footer>
                                    <div style="font-size: 14px;">{{item.name}}</div>
                                </template>
                            </tgl-image-cloud-upload>
                            <div class="size-advice f-hide-col-1" style="text-align: center">尺寸：670*376</div>
                        </div>
                    </div>
                    <div class="img-upload" v-else-if="item.enName === 'qq'">
                        <tgl-image-cloud-upload class="hide-add-icon" :editBtn="true" :isCrop="true"
                            :domWidth="207" :domHeight="124" :maxSize="30720" :height="128" :width="128"
                            extra="qq" :btnId="item.enName" :ref="'imgUpload'+item.enName" @completed="imageUploadCompleted"
                            :choiceType="item">
                            <template #text>
                                <div class="upload-text">上传封面图：</div>
                                <div class="upload-text">最大：30K，尺寸：128*128</div>
                            </template>
                            <template #footer>
                                <div style="font-size: 14px;">{{item.name}}</div>
                            </template>
                        </tgl-image-cloud-upload>
                        <div class="size-advice f-hide-col-1" style="text-align: center">尺寸：128*128，最大：30K</div>
                        <br>
                        <div style="display: inline-block">
                            <tgl-image-cloud-upload class="hide-add-icon" :editBtn="true" :isCrop="true"
                                :domWidth="207" :domHeight="124" :maxSize="60200" :width="750" :height="422"
                                extra="qq_recommend" :btnId="item.enName+'Extra'" :ref="'imgUpload'+item.enName"
                                :choiceType="{name:item.name, cover:item.coverExtra}" @completed="imageUploadCompleted">
                                <template #text>
                                    <div class="upload-text">上传推荐图：</div>
                                    <div class="upload-text">最大：50K，尺寸：750*422</div>
                                </template>
                                <template #footer>
                                    <div style="font-size: 14px;">{{item.name}}</div>
                                </template>
                            </tgl-image-cloud-upload>
                            <div class="size-advice f-hide-col-1" style="text-align: center">尺寸：750*422，最大：50K</div>
                        </div>
                    </div>
                    <div class="img-upload" v-else-if="item.enName === 'kandian'">
                        <tgl-image-cloud-upload class="hide-add-icon" :editBtn="true" :isCrop="true"
                            :domWidth="207" :domHeight="124" extra="kandian" :maxSize="6*1024*1024" :width="900"
                            :height="500" :choiceType="item" :btnId="item.enName+item.accountId" :ref="'imgUpload'+item.enName"
                            @completed="imageUploadCompleted">
                            <template #text>
                                <div class="upload-text">单个文件最大支持6MB</div>
                                <div class="upload-text">支持jpg/png格式</div>
                            </template>
                            <template #footer>
                                <div style="font-size: 14px;">{{item.name}}</div>
                            </template>
                        </tgl-image-cloud-upload>
                        <div class="size-advice f-hide-col-1" style="text-align: center">尺寸：900*500</div>
                    </div>
                    <div class="img-upload" v-else>
                        <tgl-image-cloud-upload class="hide-add-icon" :editBtn="true" :isCrop="true"
                            :domWidth="207" :domHeight="124" extra="kandian" :maxSize="6*1024*1024" :btnId="item.enName"
                            :ref="'imgUpload'+item.enName" @completed="imageUploadCompleted" :choiceType="item">
                            <template #text>
                                <div class="upload-text">封面图</div>
                                <div class="upload-text">单个文件最大支持6MB</div>
                            </template>
                            <template #footer>
                                <div style="font-size: 14px;">{{item.name}}</div>
                            </template>
                        </tgl-image-cloud-upload>
                        <div class="size-advice f-hide-col-1" style="text-align: center">单个文件最大支持6MB</div>
                    </div>
                    <div class="text-block">
                        <div class="title" style="margin-bottom: 1rem">
                            <div class="channel-subname-text" style="font-size: 16px;color: #666">
                                <img class="select-icon" :src="item.logo" alt="" style="width: 20px;height: 20px">
                                {{ item.currentAccountName}}
                            </div>
                        </div>
                        <div class="title">
                            <input class="title-textarea" rows="1" maxlength="30" placeholder="请输入内容标题（30个字以内）"
                                v-model="item.title">
                            <!-- 错误提示 -->
                            <!--<p class="error-prompt">未输入标题</p>-->
                        </div>
                        <!--<div class="introduction">-->
                        <!--<textarea class="introduction-textarea" maxlength="200" placeholder="请输入简介（200个字以内）"></textarea>-->
                        <!--</div>-->
                        <div class="abstract edit-text">
                            <input type="text" class="title-textarea" rows="1" maxlength="50" placeholder="请输入简介（50个字以内）"
                                v-model="item.summary">
                            <span class="wordsNum">
                                <em class="wordsNum-dynamic">{{ item.summary && item.summary.length || 0}}</em>/
                                <em class="wordsNum-fixed">50</em>
                            </span>
                        </div>
                        <!--:multiple="item.enName === 'wx'"-->
                        <div class="classify" style="border: transparent;margin-top: 5px">
                            <el-select clearable style="width: 100%" v-model="item.category" :multiple="item.enName === 'wx'"
                                filterable placeholder="请选择分类">
                                <el-option v-for="cate in mediaCategory[item.enName]" :key="cate.name" :label="cate.name"
                                    :value="cate.id"></el-option>
                            </el-select>
                        </div>
                        <!--关联词手动输入、2-5个-->
                        <div class="classify" style="border: transparent;margin-top: 5px">
                            <el-select style="width: 100%" v-model="item.tags" multiple filterable
                                default-first-option placeholder="请填写关键词">
                                <el-option v-for="keyword in gameKeywordList" :key="keyword.keywordName+keyword.id"
                                    :label="keyword.keywordName" :value="keyword.id"></el-option>
                            </el-select>
                        </div>
                    </div>
                </li>
            </ul>
        </div>
    </div>
</template>

<style  lang="scss" scoped>
@import '~Assets/sass/pages/v4/order/contribution.scss';
@import '~Assets/sass/pages/v4/order/order.scss';
@import '~Assets/sass/pages/v4/order/order_contribute.scss';
.hide-add-icon {
    /deep/ .icon-plus {
        display: none;
    }
}
</style>

<script>
import {
    UserMediaAccountGroup,
    UserMediaAccountList,
    MediaPubAccountGroup,
    PublicMediaAccountList,
    MediaCategories,
    GameKeywords
} from "Services/getData.js";
import imgUpload from "Components/v4/upload/imgUpload_v4";
import selectBox from "Components/v4/dropdown/select_box";
import ChannelGroupCon from "./ChannelGroupCon";

import { mapGetters } from "vuex";

const noAutoMedia = ["wx", "kandian", "qq"];
const needVideoMedia = [
    "iqiyi",
    "youku",
    "toutiao",
    "om",
    "vqq",
    "baijiahao",
    "dayu",
    "hupu"
];

function mediasFilter({
    title, // 标题
    summary, // 简介
    category, // 分类
    tags, // 关键词
    cover, // 图1
    coverExtra, // 图2
    accountId,
    enName
}) {
    if (typeof category === "object") {
        // 非字符串时
        category = category.join(",");
    }
    if (tags && tags.length) {
        tags = tags.join(",");
    }
    return {
        title, // 标题
        summary, // 简介
        category, // 分类
        tags, // 关键词
        cover, // 图1
        coverExtra, // 图2
        accountId,
        enName
    };
}

export default {
    name: "media_distribute.vue", // 个人账号，官方账号分发信息
    props: {
        curGameId: null,
        covers: Array,
        title: String,
        contentType: {
            // {0: 'article', 1: 'video', 2: 'novel', 3: 'cartoon' }
            type: String,
            default: function () {
                return "article";
            }
        },
        isVidDistribute: {
            type: Number,
            default: 0
        },
        hasVideoId: {
            type: Number,
            default: 0
        },
        medias: {
            type: Array,
            default: () => {
                return [];
            }
        },
        defaultSelectedMediaList: {
            type: Array,
            default: () => {
                return [];
            }
        }
    },
    data() {
        return {
            userMediaGroup: [],
            pubMediaGroup: [],

            selectedMediaList: [],
            selectedAccountId: [],

            customDistributeMode: false,
            mediaCategory: {},
            gameKeywordList: []
        };
    },
    computed: {
        ...mapGetters(["mediaDistributeCovers", "mediaDistributeData"])
    },
    components: {
        imgUpload,
        selectBox,
        ChannelGroupCon
    },
    mounted() {
        this.getMedia();
    },
    watch: {
        curGameId: {
            handler(id) {
                this.getPubMediaGroup();
                this.getMediaKeywords(id);
            },
            deep: true
        },
        selectedMediaList: {
            handler(list) {
                const medias = list.map(mediasFilter);
                this.$emit("update:medias", medias);
            },
            deep: true
        },
        customDistributeMode: {
            handler(custom) {
                if (!custom) {
                    // 智能编目
                    const medias = this.selectedMediaList.filter(
                        ({ accountId, enName }) => {
                            return {
                                accountId,
                                title: "",
                                category: "",
                                summary: "",
                                cover: "",
                                coverExtra: "",
                                tags: "",
                                enName
                            };
                        }
                    );
                    this.$emit("update:medias", medias);
                }
            },
            deep: true
        },
        defaultSelectedMediaList: {
            handler(list) {
                this.getPubMediaGroup().then(() => {
                    if (list.length) {
                        this.customDistributeMode = true;
                    }

                    // TODO: 这段还需优化
                    this.selectedMediaList = [];
                    list.map(sMedia => {
                        if (this.mediaCategory[sMedia.enName]) {
                            this.$nextTick(() => {
                                this.selectedMediaList.push(sMedia);
                            });
                        } else {
                            this.getMediaCategories(sMedia.enName).then(() => {
                                this.selectedMediaList.push(Object.assign({}, sMedia));
                            });
                        }
                    });

                    this.selectedAccountId = list.map(({ accountId }) => accountId);
                    this.resetSelectedMediaList();

                    const medias = list.map(mediasFilter);
                    this.$emit("update:medias", medias);
                });
            },
            deep: true
        }
    },
    methods: {
        resetParam(isChangeTab = false) {
            this.selectedMediaList = [];
            this.getMedia(isChangeTab);
        },
        getMedia(isChangeTab = false) {
            this.getUserMediaGroup(isChangeTab);
            this.getPubMediaGroup();
        },
        // 重置账号选择，依赖 pubMediaGroup、userMediaGroup、selectedAccountId
        resetSelectedMediaList() {
            // 重置公共媒体
            this.pubMediaGroup.filter(media => {
                media.account.filter(account => {
                    if (this.selectedAccountId.includes(account.id)) {
                        // 选中当前媒体，并设为默认账号
                        media.isSelected = true;
                        media.currentAccount = account;
                        media.accountId = account.id;
                        media.expire = account.expire;
                    }
                });
            });
            // 重置个人账号
            this.userMediaGroup.filter(media => {
                media.account.filter(account => {
                    if (this.selectedAccountId.includes(account.id)) {
                        // 选中当前媒体，并设为默认账号
                        media.isSelected = true;
                        media.currentAccount = account;
                        media.accountId = account.id;
                        media.expire = account.expire;
                    }
                });
            });
        },
        editDistributeInfo() {
            if (this.selectedMediaList.length === 0) {
                this.$alert("请先选择媒体~");
                return false;
            }
            this.switchDistributeMode();
        },
        imageUploadCompleted(res) {
            let url = res.url;
            let id = res.btnId;
            this.selectedMediaList.map(v => {
                if (id.includes(v.enName)) {
                    if (id.includes("Extra")) {
                        v.coverExtra = url;
                    } else {
                        v.cover = url;
                    }
                }
                return v;
            });
        },
        // 同一个QQ号绑定的 企鹅号、 腾讯视频只能选同一个账号 TODO: test
        testOMandVQQ(media) {
            return this.selectedMediaList.reduce(
                (state, { qq, enName }) => state || (qq !== media.qq &&
                    ((enName === "om" && media.enName === "vqq") ||
                        (enName === "vqq" && media.enName === "om"))
                ),
                false);
        },
        // 过期跳转绑定页确认
        expireConfirm() {
            this.$confirm("账号授权已过期,是否前往媒体账号重新绑定?", "提示", {
                type: "warning"
            })
                .then(() => {
                    this.$router.push({
                        name: "v4-manage-account"
                    });
                })
                .catch(() => { });
        },
        // 删除和选中媒体
        selectMedia(media, isqq) {
            // 可选条件
            if (media.expire) {
                this.expireConfirm();
                return false;
            }
            if (["youku", "iqiyi", "vqq"].includes(media.enName) &&
                ["article", "cartoon", "novel"].includes(this.contentType)
            ) {
                this.$alert("该媒体不支持图文、小说、漫画内容~");
                return false;
            }
            if (!media.isSelected &&
                this.contentType === "video" &&
                this.hasVideoId === 0 &&
                needVideoMedia.includes(media.enName)
            ) {
                this.$alert("请上传视频源文件~");
                return false;
            }
            if (this.contentType === "video" &&
                ["om", "vqq"].includes(media.enName) &&
                this.testOMandVQQ(media)
            ) {
                this.$alert("企鹅号、 腾讯视频只能选同一个QQ账号分发~");
                return false;
            }
            if (!media.isSelected &&
                this.selectedMediaList.reduce((state, { enName }) => state || enName === media.enName, false)
            ) {
                this.$alert("同媒体下个人账号和公用账号只能二选一~");
                return false;
            }

            // 数据加载
            if (this.gameKeywordList.length === 0) {
                this.getMediaKeywords();
            }

            // 切换选中状态
            media.isSelected = !media.isSelected;
            if (media.isSelected) {
                // 选中媒体，先拉取媒体的category
                this.getMediaCategories(media.enName).then(() => {
                    media.gameId = this.curGameId;
                    // 微信游戏圈封面图需要个性编目
                    media.cover = noAutoMedia.includes(media.enName)
                        ? ""
                        : this.mediaDistributeCovers;
                    const { title, summary, keywords } = this.mediaDistributeData;
                    media.title = title;
                    media.summary = summary;
                    media.tags = keywords
                        ? keywords.split(",").map(v => parseInt(v))
                        : [];

                    // 状态无误的时候，不可能添加一个已存在媒体
                    this.selectedMediaList.push(media);
                });
                if (noAutoMedia.includes(media.enName)) {
                    this.customDistributeMode = true;
                }
            } else {
                // 删除媒体
                media.cover = "";
                // 状态无误的时候 this.selectedMediaList 不为 []
                const key = this.selectedMediaList.reduce(
                    (key, { accountId }, k) =>
                        key || (media.accountId === accountId ? k + 1 : 0),
                    0
                );
                // 状态无误的时候，k>=1
                this.selectedMediaList.splice(key - 1, 1);
                if (this.selectedMediaList.length === 0) {
                    this.customDistributeMode = false;
                }
            }
        },
        // 账号选择
        selectAccount(media, account) {
            // 可选条件
            if (account.expire) {
                this.expireConfirm();
                return false;
            }
            if (this.contentType === "video" &&
                ["om", "vqq"].includes(media.enName) &&
                this.testOMandVQQ(media)
            ) {
                this.$alert("企鹅号、 腾讯视频只能选同一个QQ账号分发~");
                return false;
            }

            // 切换账号
            const key = this.selectedMediaList.reduce(
                (key, { accountId }, k) =>
                    key || (media.accountId === accountId ? k + 1 : 0),
                0
            );

            media.currentAccount = account;
            media.accountId = account.id;
            media.qq = account.qq;
            media.expire = account.expire;
            media.currentAccountName = account.accountName;
            media.expire = account.expire;

            const [old] = this.selectedMediaList.splice(key - 1, 1);
            if (!old) {
                return;
            }
            ["title", "summary", "category", "cover", "coverExtra"].forEach(v => {
                // FIXED: sentry.oa.com/Tencent/tglqqcom/issues/5061360/
                media[v] = old && old[v] ? old[v] : media[v];
            });

            media.tags = old && (old.tags.length ? old.tags : media.tags);
            this.selectedMediaList.splice(key - 1, 0, media);
        },
        async getUserMediaGroup(isChangeTab = false) {
            const res = await UserMediaAccountGroup();
            if (res.data && res.data.data.length) {
                const data = res.data.data;
                this.userMediaGroup = data.map(media => {
                    media.isPublic = 0;
                    media.isSelected = false;
                    const [account] = media.account;
                    media.currentAccount = account;
                    media.accountId = account.id;
                    media.qq = account.qq;
                    media.currentAccountName = account.accountName;
                    media.expire = account.expire;
                    // 后端参数需要, 保存媒体分发接口接受的关键词字段为 tags
                    media.category = [];
                    media.tags = [];
                    media.title = "";
                    media.cover = "";
                    media.summary = "";
                    media.coverExtra = "";
                    return media;
                });
                if (isChangeTab) {
                    setTimeout(() => {
                        this.$refs.personMediaAccount.getDefaultMedia()
                    }, 2000)
                }
            }
        },
        async getPubMediaGroup(gameId = this.curGameId) {
            const res = await MediaPubAccountGroup({ gameId });
            if (res.data && res.data.data.length) {
                const data = res.data.data;
                this.pubMediaGroup = data.map(media => {
                    media.isPublic = 1; // 是否为公共媒体
                    media.isSelected = false;
                    const [account] = media.account;
                    media.currentAccount = account;
                    media.accountId = account.id;
                    media.qq = account.qq;
                    media.currentAccountName = account.accountName;
                    media.expire = account.expire;
                    // 后端参数需要, 保存媒体分发接口接受的关键词字段为 tags
                    media.category = [];
                    media.tags = [];
                    media.title = "";
                    media.cover = "";
                    media.summary = "";
                    media.coverExtra = "";
                    return media;
                });
            }
        },
        // 拉取外部媒体分类信息
        async getMediaCategories(mediaName) {
            const res = await MediaCategories({
                mediaName,
                gameId: this.curGameId
            });
            if (res.data && res.data.data.length) {
                this.mediaCategory[mediaName] = res.data.data.map(([id, name]) => ({
                    id,
                    name
                }));
            }
        },
        // 保存媒体分发接口接受的关键词字段为 tags
        async getMediaKeywords(gameId = this.curGameId) {
            const res = await GameKeywords({
                gameId
            });
            if (res.data && res.data.data.length) {
                this.gameKeywordList = res.data.data;
            }
        },
        // 切换编目模式
        switchDistributeMode() {
            if (!this.customDistributeMode) {
                this.$confirm(
                    "个性编目状态下，标题和封面图的修改不会同步到渠道的编目信息。",
                    "确认开启手动编目？"
                )
                    .then(() => {
                        this.customDistributeMode = !this.customDistributeMode;
                    })
                    .catch(() => { });
            } else {
                // 选中wx游戏圈和看点无法选择智能编目
                let haswxorKandainMedia = false;
                this.selectedMediaList.filter(media => {
                    if (noAutoMedia.includes(media.enName)) haswxorKandainMedia = true;
                });

                if (haswxorKandainMedia) {
                    this.$alert(
                        "分发账号包含微信游戏圈、看点、手Q，无法智能编目，请完成个性编目信息~"
                    );
                    return false;
                }
                this.$confirm(
                    "智能编目状态下，标题和封面图的修改会同步到渠道的编目信息。",
                    "确认开启智能编目？"
                )
                    .then(() => {
                        this.customDistributeMode = !this.customDistributeMode;
                    })
                    .catch(() => { });
            }
        }
    }
};
</script>
